module.exports = __webpack_public_path__ + "img/stcode.34c07c9d.png";